import { GET_QUESTIONNAIRES, VENDOR_RISK_REGISTER_QUESTION_BY_ID,GET_CERTIFICATE_DATA_ACCESS, GET_CERTIFICATE_CRITICAL_FINDINGS, RISK_REGISTER_VENDOR, EMAIL_SUGGESTION,RISK_REGISTER_QUESTION_BY_ID, REVIEW_RESPONSE, VENDOR_QUESTIONNAIRES_TOTAL, RISK_REGISTER, SHOWDETAILS_VENDOR_QUESTIONNAIRES_DASHBOARD, VENDOR_QUESTIONNAIRES_DASHBOARD, SENT_QUESTIONNAIRES_TOTAL,GET_CERTIFICATE_ASSESSMENT_HISTORY, GET_QUESTIONNAIRES_BY_ID, SENT_QUESTIONNAIRES_DASHBOARD, GET_CERTIFICATE, GET_RISK_DISTRIBUTION, GET_VENDOR_SERVICE_PROFILES } from "../actions";

const initialState = {
  loading: true,
  response: null,
  questionnaireById: null,
  sentQuestionnaire: [],
  vendorQuestionnaireList: [],
  totalDashboard: [],
  vendorTotalDashboard: [],
  showDetailsvendorQuestionnaire: [],
  rescreated: null,
  list: null,
  data: null,
  fetchedData: {},
  formSubmit: null,
  emailSuggestion: [],
  riskRegistor:[],
  reviewResponse:[],
  riskRegisterById:[],
  riskRegisterVendorById:[],
  riskRegisterVendor:[],
  certificate:[],
  assessmentHistory:[],
  criticalFindings:[],
  certificateDataAccess:[],
  riskDistribution: null,
  vendorServiceProfiles: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case REVIEW_RESPONSE:
      return {
        ...state,
        reviewResponse: action.payload,
      };
    case RISK_REGISTER_QUESTION_BY_ID:
      return {
        ...state,
        riskRegisterById: action.payload,
      };
    case VENDOR_RISK_REGISTER_QUESTION_BY_ID:
        return {
          ...state,
          riskRegisterVendorById: action.payload,
        };
    case EMAIL_SUGGESTION:
      return {
        ...state,
        emailSuggestion: action.payload,
      };
      case RISK_REGISTER:
        return {
          ...state,
          riskRegistor: action.payload,
        };
        case RISK_REGISTER_VENDOR:
        return {
          ...state,
          riskRegisterVendor: action.payload,
        };
    case GET_QUESTIONNAIRES:
      return {
        ...state,
        response: action.payload,
      };
    case GET_QUESTIONNAIRES_BY_ID:
      return {
        ...state,
        questionnaireById: action.payload,
      };
    case SENT_QUESTIONNAIRES_DASHBOARD:
      return {
        ...state,
        sentQuestionnaire: action.payload,
      };
    case VENDOR_QUESTIONNAIRES_DASHBOARD:
      return {
        ...state,
        vendorQuestionnaireList: action.payload,
      };
    case SENT_QUESTIONNAIRES_TOTAL:
      return {
        ...state,
        totalDashboard: action.payload,
      };
    case VENDOR_QUESTIONNAIRES_TOTAL:
      return {
        ...state,
        vendorTotalDashboard: action.payload,
      };
    case SHOWDETAILS_VENDOR_QUESTIONNAIRES_DASHBOARD:
      return {
        ...state,
        showDetailsvendorQuestionnaire: action.payload,
      };
      case GET_CERTIFICATE:
        return {
          ...state,
          certificate: action.payload,
        };
        case GET_CERTIFICATE_ASSESSMENT_HISTORY:
          return {
            ...state,
            assessmentHistory: action.payload,
          };  
          case GET_CERTIFICATE_CRITICAL_FINDINGS:
            return {
              ...state,
              criticalFindings: action.payload,
            };  
            case GET_CERTIFICATE_DATA_ACCESS:
              return {
                ...state,
                certificateDataAccess: action.payload,
              };    
    case GET_RISK_DISTRIBUTION:
      return {
        ...state,
        riskDistribution: action.payload,
      };
    case GET_VENDOR_SERVICE_PROFILES:
      return {
        ...state,
        vendorServiceProfiles: action.payload,
      };
    default:
      return state;
  }
}
